import * as React from 'react';
import { MeatballMenu, PromptConfirmationModal, withDropdownMenu } from 'ui';
import { DropdownMenuContext } from 'ui/common/dropdown-menu/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { ids } from '../../constants';
import { TextConfigurationTranslation } from '../../../constants';

import styles from './code-description-toolbar.scss';

interface CodeDescriptionToolbarProps {
  totalResultHits: number;
  exportExcelFetching: boolean;
  importExcelFetching: boolean;
  onExportToExcel: () => void;
  openExcelImport: () => void;
  translation: TextConfigurationTranslation;
}

const CodeDescriptionToolbarComponent: React.FC<CodeDescriptionToolbarProps & DropdownMenuContext> = props => {
  const { totalResultHits, exportExcelFetching, importExcelFetching,
    onExportToExcel, openExcelImport, handleDropdownHide, translation } = props;
  const isExportDisabled = exportExcelFetching || totalResultHits === 0 || totalResultHits === undefined;

  const exportToExcelHandler = () => {
    handleDropdownHide && handleDropdownHide();
    onExportToExcel && onExportToExcel();
  };

  const openExcelImportHandler = () => {
    handleDropdownHide && handleDropdownHide();
    openExcelImport && openExcelImport();
  };

  return <div className="row">
    <h1 className="col-10">{translation.code_descriptions}</h1>
    <div className="col-2">
      <div className={styles.meatball}>
        <MeatballMenu>
          <li className={`${isExportDisabled ? styles.notAllowed : ''}`}>
            <PromptConfirmationModal
              title={translation.excel_export_item_text}
              description={replaceTemplateString(
                translation.excel_export_confirmation,
                totalResultHits
              )}
              continueText={translation.excel_export_item_text}
              cancelText={translation.cancel}
              onContinue={exportToExcelHandler}>
              <button className="dropdown-item"
                id={ids.export_to_excel}
                disabled={isExportDisabled}>
                {translation.excel_export_item_text}
              </button>
            </PromptConfirmationModal>
          </li>
          <li className={`${importExcelFetching ? styles.notAllowed : ''}`}>
            <button className="dropdown-item"
              id={ids.import_from_excel}
              onClick={openExcelImportHandler}
              disabled={importExcelFetching}>
              {translation.import_from_excel}
            </button>
          </li>
        </MeatballMenu>
      </div>
    </div>
  </div>;
};

export const CodeDescriptionToolbar = withDropdownMenu(CodeDescriptionToolbarComponent);
